export enum Path {
  Home = 'account',
  Reports = 'reports',
  Requests = 'employee-applications',
  Archive = 'archive',
  Settings = 'settings',
  Taxes = 'taxes',
  Permissions = 'permissions',
  Settlements = 'settlements',
  NotFound = 'not-found',
  News = 'news',
}
